import { Route } from "react-router";
import {
  COPY_RECIPE,
  EDIT_RECIPE,
  NEW_RECIPE,
  RECIPE,
  RECIPES,
} from "@routes/routes";
import {
  RecipeHeaderLayout,
  RecipeCopyPage,
  RecipeEditPage,
  RecipeNewPage,
  RecipePage,
  RecipesPage,
} from "@routes/lazyPages";

/** Recipes — list, preview, editor and copy. */
export const recipeRoutes = (
  <>
    <Route path={RECIPES} lazy={RecipesPage} />
    <Route path={NEW_RECIPE} lazy={RecipeNewPage} />
    <Route lazy={RecipeHeaderLayout}>
      <Route path={RECIPE} lazy={RecipePage} />
      <Route path={EDIT_RECIPE} lazy={RecipeEditPage} />
      <Route path={COPY_RECIPE} lazy={RecipeCopyPage} />
    </Route>
  </>
);
